import mixins from 'synergycms_core/src/less/mixins';

export default {
  
  bestPrice: {
    padding: '15px 0 0 10px',
    position: 'relative',
    marginBottom: '-15px',
    '& > span': {
      font: data => '300 13px/1.38 ' + data.fontFamily1,
      background: '#fff',
      textTransform: 'uppercase',
      padding: '7px 8px 7px 36px',
      display: 'block',
      '&:lang(ar)':{
        paddingRight: "36px",
        paddingLeft: "8px",
        textAlign: "right"
      }
    },
    '@media(min-width:801px)': {
      paddingTop: '0',
      marginBottom: '-5px'
    },
    '&:lang(ar)':{
      paddingRight:'10px',
      paddingLeft:0
    }
  },
  bestPriceIcon: {
    background: '#4a90e2',
    ...mixins.mixinBorderRadius('50%'),
    fontSize: '17px',
    lineHeight: '17px',
    padding: '11px',
    color: '#fff',
    zIndex: '2',
    position: 'absolute',
    left: '0',
    top: '10px',
    '@media(min-width:801px)': {
      top: '-5px'
    },
    '&:lang(ar)':{
      left:'auto',
      right:0
    }
  },
  hotelContent: {},
  mapContent: {},
  fixedSeeMap: {},
  toggleMapButton: {},
  svgIcon: {},
  fontSize12: {
    fontSize: '11px'
  },
  defaultStyle: {
    fontFamily: data => data.fontFamily1,
    minHeight:'calc(100vh - 29px)',
    display:'flex',
    flexDirection:'column',
    flexWrap:'wrap',
    '@media(min-width:901px)':{
      minHeight:'calc(100vh - 62px)',
    },
    '& $hotelContent': {
      minHeight: '100vh',
      position: 'relative',
      //backgroundColor: '#ebebeb',
      '&:lang(ar)': {
        direction:'rtl',
        '@media (min-width: 1301px)': {
          marginLeft: 'auto',
          marginRight: 0
        }
      },
      '& > ul': {
        margin: '0',
        padding: '20px 20px 130px',
        listStyle: 'none',
        background: '#fff',
        '& > li': {
          maxWidth: '1180px',
          margin: '0 auto 30px',
          '&:last-of-type': {
            marginBottom: 0
          },
          '& > div': {
            boxShadow: 'none',
            '& > div > div > div > span:nth-child(3)': {
              whiteSpace: 'normal',
            }
          },
        },
        '@media(max-width:800px)': {
          padding: '15px 10px 170px',
        },
        '@media(min-width:801px)':{
          '&:lang(ar)': {
            padding: '20px 30px 130px 20px',
          },
        }
      },
      '@media(min-width:1301px)': {
        width: '850px'
      }
    },
    '& $mapContent': {
      position: 'fixed',
      left: '0',
      top: '0',
      right: '0',
      bottom: '0',
      zIndex: '3',
      overflow:'hidden',
      '&:lang(ar)': {
        '@media (min-width: 1301px)': {
          right: '850px',
          left: 0
        }
      },
      '@media (max-width: 1301px)': {
        top: '147px',
        bottom: '75px'
      },
      '@media (min-width: 1301px)': {
        left: '850px'
      }
    },
    '& $fixedSeeMap': {
      //...mixins.boxShadow('0 2px 11px 0px #000'),
      position: 'sticky',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: '3',
      background: '#fff',
      textAlign: 'center',
      padding: '15px',
      borderTop: 'solid 0.5px #d8d8d8',
    },
    '& $toggleMapButton': {
      ...mixins.boxSizing(),
      height: '45px',
      position: 'relative',
      padding: '0 15px 0 30px',
      width: 'auto',
      '&:hover': {
        '& svg': {
          fill: '#fff'
        }
      },
      '&:lang(ar)':{
        padding:'0 30px 0 15px'
      }
    },
    '& $svgIcon': {
      fill: data => data.mainColor,
      marginTop: '-7px',
      position: 'absolute',
      top: '50%',
      left: '7px',
      width: '14px',
      height: '14px',
      '&:lang(ar)':{
        left:'auto',
        right:'7px'
      }
    },
    '&:lang(ar)': {
      direction: 'rtl',
    }
  }
};
